<div class="site-loader">
    <div>{{ 'common.loading' | translate }}</div>
</div>
